import * as Yup from 'yup';

export default Yup.object().shape({
  currentPassword: Yup.string().required('Obrigatório. preencha a senha atual'),
  newPassword: Yup.string()
    .matches(
      /^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[!@#$%^&*])(?=.*[A-Z]).*$/,
      'Senha inválida',
    )
    .required('Obrigatório. Preencha uma nova senha.'),
  confirmedNewPassword: Yup.string()
    .required('Obrigatório. Preencha uma nova senha.')
    .oneOf([Yup.ref('newPassword'), null], 'As senhas precisam ser iguais.'),
});
